export default "__VITE_ASSET__CiBrZaUy__"